export default "__VITE_ASSET__CBuUubcc__"